export default __webpack_public_path__ + "static/media/Venus.b91f4f51.jpg";